import { render, staticRenderFns } from "./RegulationsActivity.vue?vue&type=template&id=7cdfff3a&scoped=true&"
import script from "./RegulationsActivity.vue?vue&type=script&lang=js&"
export * from "./RegulationsActivity.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsActivity.vue?vue&type=style&index=0&id=7cdfff3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdfff3a",
  null
  
)

export default component.exports